
import { defineComponent, ref, computed, toRef } from "vue";

import ChargebackActions from "@/components/dropdown/ChargebackActions.vue";

export default defineComponent({
  name: "chargebacks-action-toolbar",
  components: { ChargebackActions },
  props: {
    incomingData: { type: Object, required: true },
    processor: { type: Object, required: true },
    apiSyncItems: Array,
    connections: Array,
  },
  emits: ["reload-incoming", "open-drawer", "form-entry", "view-dispute"],
  setup(props, { emit }) {
    const incoming = toRef(props, "incomingData");
    const openResponseDrawerBtn = ref<HTMLButtonElement | null>(null);
    const showProgress = ref(false);

    const onOpenResponseDrawer = async () => {
      if (incoming.value.sent_date !== "0000-00-00 00:00:00") {
        emit("view-dispute");
      } else {
        emit("open-drawer");
      }
    };

    const onFormEntry = async () => {
      emit("form-entry");
    };

    const getIncomingPercent = computed(() => {
      if (incoming.value) {
        return (Number(incoming.value.details_populated) / 4) * 100;
      }

      return 0;
    });

    const reloadIncoming = () => {
      emit("reload-incoming");
    };

    const onAction = (val) => {
      showProgress.value = val;
    };

    return {
      incoming,
      openResponseDrawerBtn,
      onOpenResponseDrawer,
      onFormEntry,

      getIncomingPercent,
      reloadIncoming,
      showProgress,
      onAction,
    };
  },
});
